import { Component, State, h } from '@stencil/core';
import { isBrowser } from '../../constants/constants';
import { rollbar } from '../../utils/rollbar';

const checkoutLink = `${process.env.CI_HOSTNAME}/checkout/summary`;

@Component({
  tag: 'ci-cart',
  styleUrl: 'ci-cart.scss',
  shadow: true,
})
export class CiCart {
  @State() cartCount: number;

  // Static class variables shared across all instances
  private static isInitialized = false;
  private static sharedCartCount: number = 0;
  private static listeners: Set<() => void> = new Set();

  private static async refreshCartCount() {
    const newCount = await CiCart.fetchCartCount();

    CiCart.sharedCartCount = newCount;
    // Notify all instances of the update
    CiCart.listeners.forEach(listener => listener());
  }

  private static async fetchCartCount() {
    try {
      const response = await window.fetch(`${window.location.origin}/api/checkout/cart?include_pricing=false&src=ci-cart`);
      const cart = await response.json();
      return cart.total_items;
    } catch (error) {
      rollbar.error('Error during fetching cart checkout', error);
      return 0;
    }
  }

  private updateLocalCount = () => {
    this.cartCount = CiCart.sharedCartCount;
  };

  async componentWillLoad() {
    // Only initialize once across all instances
    if (!CiCart.isInitialized) {
      CiCart.isInitialized = true;
      CiCart.refreshCartCount().catch(error => rollbar.error('Error refreshing cart cookie:', error));
      window.addEventListener('cartCookieUpdated', CiCart.refreshCartCount);
      window.addEventListener('ciCartUpdated', CiCart.refreshCartCount);
    }

    // Add this instance's listener
    CiCart.listeners.add(this.updateLocalCount);
    this.cartCount = CiCart.sharedCartCount;
  }

  disconnectedCallback() {
    CiCart.listeners.delete(this.updateLocalCount);

    // Only remove global listener if no instances remain
    if (CiCart.listeners.size === 0) {
      window.removeEventListener('cartCookieUpdated', CiCart.refreshCartCount);
      window.removeEventListener('ciCartUpdated', CiCart.refreshCartCount);
      CiCart.isInitialized = false;
    }
  }

  redirectToCart() {
    window.location.href = checkoutLink;
  }

  render() {
    const cartCount = isBrowser ? this.cartCount : 0;
    return (
      <div class="ciHeader-cart">
        {cartCount > 0 && (
          <div class="ciHeader-cart-count" onClick={this.redirectToCart}>
            {cartCount}
          </div>
        )}
        <a class="ghf-icon-button ciHeader-cart-icon-button" href={checkoutLink} data-testid="cart-global-header">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3H3.14551L5.9456 20.7339C6.06072 21.463 6.68914 22 7.42725 22H19C19.5523 22 20 21.5523 20 21C20 20.4477 19.5523 20 19 20H7.85449L7.5387 18H18.3308C19.7807 18 21.0231 16.9631 21.2825 15.5367L22.8767 6.76833C23.0441 5.84757 22.3368 5 21.4009 5H5.48607L5.0544 2.26606C4.93928 1.53698 4.31086 1 3.57275 1H2ZM5.80186 7L7.22292 16H18.3308C18.8141 16 19.2283 15.6544 19.3147 15.1789L20.8018 7H5.80186Z"
              fill="#4A4A4A"
            />
          </svg>
        </a>
      </div>
    );
  }
}
